export const memberConstant = {
    GETMEMBERS_REQUEST: 'GET_MEMBERS_REQUEST',
    GETMEMBERS_SUCCESS: 'GET_MEMBERS_SUCCESS',
    GETMEMBERS_FAILURE: 'GET_MEMBERS_FAILURE',
    GETBOARDMEMBERS_REQUEST: 'GET_BOARD_MEMBERS_REQUEST',
    GETBOARDMEMBERS_SUCCESS: 'GET_BOARD_MEMBERS_SUCCESS',
    GETBOARDMEMBERS_FAILURE: 'GET_BOARD_MEMBERS_FAILURE',
    GETBIOGRAPHY_REQUEST: 'GET_BIOGRAPHY_REQUEST',
    GETBIOGRAPHY_SUCCESS: 'GET_BIOGRAPHY_SUCCESS',
    GETBIOGRAPHY_FAILURE: 'GET_BIOGRAPHY_FAILURE',
    GETMEMBERSPG_REQUEST: 'GET_MEMBERS_PG_REQUEST',
    GETMEMBERSPG_SUCCESS: 'GET_MEMBERS_PG_SUCCESS',
    GETMEMBERSPG_FAILURE: 'GET_MEMBERS_PG_FAILURE',
    GETMEMBERSNK_REQUEST: 'GET_MEMBERS_NK_REQUEST',
    GETMEMBERSNK_SUCCESS: 'GET_MEMBERS_NK_SUCCESS',
    GETMEMBERSNK_FAILURE: 'GET_MEMBERS_NK_FAILURE',
    GETMEMBERSCT_REQUEST: 'GET_MEMBERS_CT_REQUEST',
    GETMEMBERSCT_SUCCESS: 'GET_MEMBERS_CT_SUCCESS',
    GETMEMBERSCT_FAILURE: 'GET_MEMBERS_CT_FAILURE',
    GETMEMBERSSOUTH_REQUEST: 'GET_MEMBERS_SOUTH_REQUEST',
    GETMEMBERSSOUTH_SUCCESS: 'GET_MEMBERS_SOUTH_SUCCESS',
    GETMEMBERSSOUTH_FAILURE: 'GET_MEMBERS_SOUTH_FAILURE',
    GETMEMBERSNORTH_REQUEST: 'GET_MEMBERS_NORTH_REQUEST',
    GETMEMBERSNORTH_SUCCESS: 'GET_MEMBERS_NORTH_SUCCESS',
    GETMEMBERSNORTH_FAILURE: 'GET_MEMBERS_NORTH_FAILURE',

    GETCITIES_REQUEST: "GET_CITIES_REQUEST",
    GETCITIES_SUCCESS: "GET_CITIES_SUCCESS",
    GETCITIES_FAILURE: "GET_CITIES_FAILURE",

    SEARCH_PER_CITY_REQUEST: "SEARCH_PER_CITY_REQUEST",
    SEARCH_PER_CITY_SUCCESS: "SEARCH_PER_CITY_SUCCESS",
    SEARCH_PER_CITY_FAILURE: "SEARCH_PER_CITY_FAILURE"
}